import { useState } from 'react'
import { FaPencilAlt, FaTrashAlt } from 'react-icons/fa'
import { FaUnlockKeyhole } from 'react-icons/fa6'

import Modal from '../../../shared/modal/Modal'
import api from '../../../utils/api'
import ConfirmDeleteModal from '../../../shared/components/ConfirmDeleteModal/ConfirmDeleteModal'
import EditSystemUser from '../EditSystemUser'
import EditSystemUserPermission from '../EditSystemUserPermission'
import useFlashMessage from '../../../hooks/useFlashMessage'

function ListSystemUserRow({ dataArray, handleOnSuccess }) {

    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    const [modalEditSystemUser, setModalEditSystemUser] = useState(false)
    const [modalEditPermission, setModalEditPermission] = useState(false)
    const [systemUserId, setSystemUserId] = useState("")
    const [modalDeleteItem, setModalDeleteItem] = useState(false)
    const [systemUserName, setSystemUserName] = useState("")

    async function deleteSystemUser(id) {
        let msgType = 'success'
        const data = await api.delete(`/user/${id}`, {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` },
        }).then((response) => {
            handleOnSuccess()
            setModalDeleteItem(false)
            return response.data
        }).catch((err) => {
            msgType = 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
    }

    return (
        <div>
            {dataArray && dataArray.map((item) => (
                <div key={item._id} className="pg-item">
                    <div className="pg-item-main">
                        <div className="pg-item-header">
                            <span className="pg-item-name">{item.name}</span>
                            {item.permission?.group && (
                                <span className="su-group-badge">{item.permission.group}</span>
                            )}
                            {item.technician && (
                                <span className="su-technician-badge">Técnico</span>
                            )}
                            {item.disabledUser && (
                                <span className="pg-item-status-disabled">Desabilitado</span>
                            )}
                        </div>
                        <span className="su-item-username">@{item.userName}</span>
                    </div>

                    <div className='shd-row-box-item-action'>
                        <FaUnlockKeyhole
                            className='su-icon-row-permission'
                            title='Permissões'
                            onClick={() => { setSystemUserId(item._id); setModalEditPermission(true) }}
                        />
                        <FaPencilAlt
                            className='shd-icon-row-edit'
                            title='Editar'
                            onClick={() => { setSystemUserId(item._id); setModalEditSystemUser(true) }}
                        />
                        <FaTrashAlt
                            className='shd-icon-row-trash'
                            title='Apagar'
                            onClick={() => { setModalDeleteItem(true); setSystemUserId(item._id); setSystemUserName(item.name) }}
                        />
                    </div>
                </div>
            ))}

            <Modal
                modalStatus={modalEditSystemUser}
                changeStatus={setModalEditSystemUser}
                w={82}
                content={
                    <EditSystemUser
                        id={systemUserId}
                        handleOnSuccess={() => { setModalEditSystemUser(false); handleOnSuccess() }}
                        btCancelAction={() => setModalEditSystemUser(false)}
                    />
                }
            />

            <Modal
                modalStatus={modalEditPermission}
                changeStatus={setModalEditPermission}
                w={70}
                content={
                    <EditSystemUserPermission
                        id={systemUserId}
                        handleOnSuccess={() => { setModalEditPermission(false); handleOnSuccess() }}
                        btCancelAction={() => setModalEditPermission(false)}
                    />
                }
            />

            <ConfirmDeleteModal
                modalStatus={modalDeleteItem}
                changeStatus={setModalDeleteItem}
                onConfirm={() => deleteSystemUser(systemUserId)}
                message="Deseja realmente excluir esse usuário?"
                itemName={systemUserName}
            />
        </div>
    )
}

export default ListSystemUserRow
